import { render } from "./IdentityRegisterForm.vue?vue&type=template&id=374aa3f7"
import script from "./IdentityRegisterForm.vue?vue&type=script&lang=js"
export * from "./IdentityRegisterForm.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__